<template>
    <div ref="foo">
        <v-row>
            <v-col class="pb-0">
                <loader class="ma-3" numb="3" :show="loading"></loader>
                <h2 class="text-center white--text text-uppercase text-shadow">NUOVI Club</h2>
            </v-col>
        </v-row>
        <v-row v-if="clubs.length > 0 && !loading">
            <v-col v-for="club_group in clubs" :key="club_group">
                <clubSheet @openDetails="openDetails" :showInfo="false" :clubs="club_group" :logoSize="60"
                    :coverHeight="40"></clubSheet>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import axios from 'axios'
import clubSheet from './clubSheet'

export default {
    name: "lastClub",
    components: {
        clubSheet
    },
    data: () => ({
        loading: true,
        clubQta: 4,
        clubs: []
    }),
    mounted() {

        if (this.$refs.foo) {
            this.loading = false;
        }

        //TODO: vedere di renderlo globale
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.$store.state._token;
        setTimeout(() => {
            this.getLastClub();
        }, 100);
    },
    methods: {
        async getLastClub() {
            this.loading = true;
            await axios
                .get(this.$store.state.ROOT_API + '/club/last/' + this.clubQta)
                .then(resp => {
                    this.clubs.push(resp.data.last);
                    this.loading = false;
                })
                .catch((error) => {
                    console.error(error)
                });
        },

        openDetails(id) {
            this.$router.push({ name: 'club', params: { club_id: id, back_to: this.$route } })
        },
    }
}
</script>

<style scoped>

</style>